<template>
  <div>
    <!-- CollectionOrder -->
    <b-form-group label="Ordem de coleta" label-for="CollectionOrder">
      <b-form-input
        id="CollectionOrder"
        type="text"
        placeholder="Ordem de coleta"
        v-model="model.collectionOrder"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['CollectionOrder']">
        {{ modelstate["CollectionOrder"][0] }}
      </span>
    </b-form-group>

  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "CargoCrudData",
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
};
</script>
